<template>
  <div class="video-block d-flex" @click="pageToVideo">
    <div class="video-each"><img src="../../../assets/img/vedio01.png" /></div>
    <div class="video-each"><img src="../../../assets/img/more.png" /></div>
    <div class="video-each"><img src="../../../assets/img/vedio02.png" /></div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    pageToVideo() {
      this.$router.push({
        path: '/video',
        query: {
          one: '体育教学',
          two: '教学视频',
          three: '',
          path: '/teaching',
          //   oneInfo: { name: item.name, path: item.href },
          //   twoInfo: { name: each.title, path: each.href },
          //   threeInfo: { name: '', path: '' },
          keepalive: 0,
          //   keepchild: 0,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/main.scss';
.video-block {
  //   width: 1100px;
  margin-top: 36px;
  margin-left: 24px;
  .video-each {
    cursor: pointer;
  }
}
</style>
